module.exports = __webpack_public_path__ + "static/img/post_6.b412d49.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media-articles/posts/post_6.png
// module id = tGen
// module chunks = 0